
import { Component, Vue } from "vue-property-decorator";
import ReportIncomingOrders from "@/views/Reporting/ReportIncomingOrders.vue";
import ReportOrdersProgress from "@/views/Reporting/ReportOrdersProgress.vue";
import ReportOrdersEvaluation from "@/views/Reporting/ReportOrdersEvaluation.vue";

@Component({
	components: {
		ReportIncomingOrders,
		ReportOrdersProgress,
		ReportOrdersEvaluation,
	},
})
export default class Reports extends Vue {
	private tab: any = 0;
}
